import axios from "axios";
import Vue from "vue";

export default {
    namespaced: true,
    state: {
        user: null,
        loggedin: false,
        firstLoad: true,
        loadingFromLogin: false,
    },
    actions: {
        async getUser({ commit, dispatch }) {
            return axios
                .get("/api/v1/user/")
                .then((result) => {
                    commit("setUser", result.data);
                    commit("setLoggedin", true);
                    commit("setFirstLoad", false);
                    dispatch("api/stripe/stripeAuthStatus", null, { root: true });
                    return result.data;
                })
                .catch(() => {
                    commit("setLoggedin", false);
                    commit("setFirstLoad", false);
                });
        },
        async getUserById(ctx, { userId }) {
            return axios.get(`/api/v1/user/${userId}`);
        },
        async login(ctx, { payload, extra }) {
            return axios
                .post("/login", payload, extra)
                .then((result) => {
                    return result;
                })
                .catch((e) => {
                    Vue.toasted.show("Unable to log you in.");
                    throw e;
                });
        },
        async logout({ commit }) {
            return axios.post("/logout").then(() => {
                commit("setUser", null);
                commit("setLoggedin", false);
                Vue.toasted.show("Logout successful", { icon: { name: "check", after: true }, duration: 2000 });
            });
        },
        async search(
            ctx,
            {
                firstName = null,
                fullName = null,
                lastName = null,
                phone = null,
                username = null,
                start = 0,
                size = 12,
                ids = null,
            }
        ) {
            return axios.post("/api/v1/user/search", {
                firstName,
                fullName,
                lastName,
                phone,
                username,
                start,
                size,
                ids,
            });
        },
        async checkAvailability(ctx, { payload, extra }) {
            if (!payload?.email) return;

            return axios
                .post("/api/v1/user/check", payload, extra)
                .then((result) => {
                    return result;
                })
                .catch((e) => {
                    console.error("Unable to check availability.");
                    throw e;
                });
        },
    },
    getters: {
        getUser(state) {
            return state.user;
        },
        getLoggedIn(state) {
            return state.loggedin;
        },
        isFirstLoad(state) {
            return state.firstLoad;
        },
        isPostingAllowed(state) {
            return (
                state.user &&
                // && state.user.phone
                state.user.billing &&
                state.user.billing.countryCode &&
                state.user.billing.postalCode &&
                state.user.billing.state &&
                state.user.billing.city &&
                state.user.billing.line1
            );
        },
        euid(state) {
            return state.user ? Vue.prototype.$helpers.safeBase64Encode(state?.user?.email) : null;
        },
        // keys for checkout preview and request payload in local storage, to be used in checkout page
        cpKey: (state, getters) => {
            return getters.euid ? `cp_${getters.euid}` : null;
        },
        crKey: (state, getters) => {
            return getters.euid ? `cr_${getters.euid}` : null;
        },
    },
    mutations: {
        setUser(state, payload) {
            Vue.set(state, "user", payload);
            // state.user = payload;
        },
        clearUser(state) {
            Vue.set(state, "user", null);
            // state.user = null;
        },
        setLoggedin(state, payload) {
            Vue.set(state, "loggedin", payload);
            // state.loggedin = payload;
        },
        setFirstLoad(state, payload) {
            Vue.set(state, "firstLoad", payload);
            // state.firstLoad = payload;
        },
    },
};
